export enum TooltipPosition {
    ABOVE = 'above',
    BELOW = 'below',
    LEFT = 'left',
    RIGHT = 'right',
    DYNAMIC = 'dynamic',
    DEFAULT = 'above'
}

export enum TooltipTheme {
    DARK = 'dark',
    LIGHT = 'light',
    DARK_LIGHT = 'dark-light',
    DEFAULT = 'dark'
}